<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">打卡人：</span>
                <el-input v-model="user_name" placeholder="打卡人模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">打卡类型：</span>
                <el-select v-model="signin_type" placeholder="请选择打卡类型">
                    <el-option
                            v-for="item in allSiginType"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="9" :lg="9" :xl="10">
                <span class="fs-14 pd-r-10">打卡时间：</span>
                <el-date-picker
                        v-model="search_expired_date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="打卡人" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="address" label="打卡位置" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="打卡时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">查看
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allSiginType: [
                    {
                        id: 1,
                        name: '外勤'
                    },
                    {
                        id: 2,
                        name: '预约'
                    },
                ],
                user_id: '',
                user_name: '',
                signin_type: '',
                end_date: '',
                start_date: '',
                search_expired_date: '',
            };
        },
        created() {
            if (this.$route.params.user_id) {
                this.user_id = this.$route.params.user_id;
                this.user_name = this.$route.params.user_name;
            }
        },
        mounted() {
            // 获取接待列表
            this.getList();
            localStorage.setItem('prev_page', 'clock_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'assistantClock',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        user_name: this.user_name,
                        signin_type: this.signin_type,
                        end_date: this.end_date,
                        start_date: this.start_date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '待审核';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '审核通过';
                                res.data.data.list[i].status_number = 2;
                                break;
                            case '3':
                                res.data.data.list[i].status = '审核不通过';
                                res.data.data.list[i].status_number = 3;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_id = "";
                this.user_name = "";
                this.signin_type = "";
                this.end_date = "";
                this.start_date = "";
                this.search_expired_date = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }

                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "clockinDetail", params: {
                        id: data.id,
                    }
                });
            },

            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'exportAssistantClock',
                    params: {
                        title_name: this.title_name,
                        status: this.status,
                    },
                };
 
                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "打卡人", key: "user_name"},
                    {title: "打卡位置", key: "address"},
                    {title: "打卡时间", key: "create_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }


                    for (var i = 0; i < res.data.data.length; i++) {
                        switch (res.data.data[i].status) {
                            case '1':
                                res.data.data[i].status = '待审核';
                                break;
                            case '2':
                                res.data.data[i].status = '审核通过';
                                break;
                            case '3':
                                res.data.data[i].status = '审核不通过';
                                break;
                        }

                        let item = {
                            id: res.data.data[i].id,
                            user_name: res.data.data[i].user_name,
                            address: res.data.data[i].address,
                            create_date: res.data.data[i].create_date,
                            status: res.data.data[i].status,
                        };
                        export_data.push(item);


                    }

                    
                    export2Excel(colums_list, export_data, "导出打卡记录");
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
